import 'html/include/js/zepto.min';
import 'html/include/js/jquery.unveil';
import 'html/include/js/zepto-anim.min';
import '@html/_common/script_es6';

import '@app/guide/styles.scss';
import '@app/guide/async.scss';

import dropin from 'braintree-web-drop-in';
import { sendRequest, parameters } from '@html/_common/utils';

function GuideTippingPage() {
  let selectedPaymentMethod = null;
  let isPaymentRequested = false;
  const FEE_PERCENTAGE = 0.05;

  const HIDDEN_CLASS = 'hid';
  const SECTION_SELECTOR = '.js-guide-tipping__section';
  const FORM_SELECTOR = '.js-guide-tipping__form';
  const CURRENCY_SELECT_SELECTOR = '.js-guide-tipping__currency-select-input';
  const RADIO_INPUTS_SELECTOR = '.js-guide-tipping__radio-input';
  const RADIO_VALUE_SELECOTR = '.js-guide-tipping__radio-value';
  const AMOUNT_INPUT_SELECTOR = '.js-guide-tipping__form-input--custom-amount';
  const AMOUNT_INPUT_PREFIX_SELECTOR = '.js-guide-tipping__form-input .scout-element__input-prefix';
  const FEE_VALUE_SELECTOR = '.js-guide-tipping__fee-value';
  const TOTAL_VALUE_SELECTOR = '.js-guide-tipping__total-value';
  const NAME_INPUT_SELECTOR = '.js-guide-tipping__form-input--full-name';
  const EMAIL_INPUT_SELECTOR = '.js-guide-tipping__form-input--email';
  const SUCCESS_CONTAINER_SELECTOR = '.js-guide-tipping__message-container--success';
  const ERROR_CONTAINER_SELECTOR = '.js-guide-tipping__message-container--error';
  const DROPIN_SECTION_SELECTOR = '.js-guide-tipping__dropin-section';
  const FORM_SUBMIT_BUTTON_SELECTOR = '.js-guide-tipping__form-submit-button';
  const FINISH_PAYMENT_BUTTON_SELECTOR = '.js-guide-tipping__final-complete-button';

  const SECTION_ELEMENTS = document.querySelectorAll(SECTION_SELECTOR);
  const FORM_ELEMENT = document.querySelector(FORM_SELECTOR);
  const CURRENCY_SELECT_ELEMENT = document.querySelector(CURRENCY_SELECT_SELECTOR);
  const RADIO_INPUTS_ELEMENTS = document.querySelectorAll(RADIO_INPUTS_SELECTOR);
  const RADIO_VALUE_ELEMENTS = document.querySelectorAll(RADIO_VALUE_SELECOTR);
  const AMOUNT_INPUT_ELEMENT = document.querySelector(AMOUNT_INPUT_SELECTOR);
  const AMOUNT_INPUT_PREFIX_ELEMENT = document.querySelector(AMOUNT_INPUT_PREFIX_SELECTOR);
  const FEE_VALUE_ELEMENT = document.querySelector(FEE_VALUE_SELECTOR);
  const TOTAL_VALUE_ELEMENT = document.querySelector(TOTAL_VALUE_SELECTOR);
  const NAME_INPUT_ELEMENT = document.querySelector(NAME_INPUT_SELECTOR);
  const EMAIL_INPUT_ELEMENT = document.querySelector(EMAIL_INPUT_SELECTOR);
  const SUCCESS_CONTAINER_ELEMENT = document.querySelector(SUCCESS_CONTAINER_SELECTOR);
  const ERROR_CONTAINER_ELEMENT = document.querySelector(ERROR_CONTAINER_SELECTOR);
  const DROPIN_SECTION_ELEMENT = document.querySelector(DROPIN_SECTION_SELECTOR);
  const FORM_SUBMIT_BUTTON_ELEMENT = document.querySelector(FORM_SUBMIT_BUTTON_SELECTOR);
  const FINISH_PAYMENT_BUTTON_ELEMENT = document.querySelector(FINISH_PAYMENT_BUTTON_SELECTOR);

  let AMOUNT_BREAKDOWN = {
    currency: null,
    baseAmount: 0,
    fee: 0,
    total: 0,
  };

  const updateCurrencySymbols = (currencyCode) => {
    if (!currencyCode) {
      return;
    }

    const currencySymbol = parameters.currency_symbols_map[currencyCode];

    FEE_VALUE_ELEMENT.dataset.currencySymbol = currencySymbol;
    TOTAL_VALUE_ELEMENT.dataset.currencySymbol = currencySymbol;
    AMOUNT_INPUT_PREFIX_ELEMENT.innerText = currencySymbol;
    RADIO_VALUE_ELEMENTS.forEach((element) => {
      // eslint-disable-next-line no-param-reassign
      element.dataset.currencySymbol = currencySymbol;
    });
  };

  AMOUNT_BREAKDOWN = new Proxy(AMOUNT_BREAKDOWN, {
    // Only allow modifying the base amount or currency and calculate price breakdown
    set(target, property, value) {
      if (property !== 'baseAmount' && property !== 'currency') {
        return false;
      }
      /* eslint-disable no-param-reassign */
      if (!value) {
        target.currency = parameters.currency;
        target.baseAmount = 0;
        target.fee = 0;
        target.total = 0;
        FEE_VALUE_ELEMENT.innerText = 0;
        TOTAL_VALUE_ELEMENT.innerText = 0;
        return true;
      }

      if (property === 'currency') {
        target.currency = value;
        updateCurrencySymbols(value);
        return true;
      }

      const parsedValue = parseFloat(value);
      // Set base amount
      target[property] = parsedValue;

      // Set and display calculated fee
      // Round to 2 decimals
      target.fee = (parsedValue * FEE_PERCENTAGE).toFixed(2);
      FEE_VALUE_ELEMENT.innerText = target.fee;

      // Set and display calculated total
      target.total = target.baseAmount + parseFloat(target.fee);
      TOTAL_VALUE_ELEMENT.innerText = target.total.toFixed(2);
      return true;
      /* eslint-enable no-param-reassign */
    },
  });

  const setBaseAmount = (amount) => {
    AMOUNT_BREAKDOWN.baseAmount = amount;
  };

  const setCurrency = (currencyCode) => {
    if (!currencyCode) {
      return;
    }

    AMOUNT_BREAKDOWN.currency = currencyCode;
  };

  const clearRadioInputs = () => {
    RADIO_INPUTS_ELEMENTS.forEach((radio) => {
      // eslint-disable-next-line no-param-reassign
      radio.checked = false;
    });
  };

  const hideSections = () => {
    SECTION_ELEMENTS.forEach((section) => {
      section.classList.add(HIDDEN_CLASS);
    });
  };

  const displayDropinSection = () => {
    hideSections();
    DROPIN_SECTION_ELEMENT.classList.remove(HIDDEN_CLASS);
    // This section is shorter then the previous so we need to scroll up
    window.scrollTo(0, 0);
  };

  const displaySuccess = () => {
    hideSections();
    SUCCESS_CONTAINER_ELEMENT.classList.remove(HIDDEN_CLASS);
  };

  const displayError = () => {
    hideSections();
    ERROR_CONTAINER_ELEMENT.classList.remove(HIDDEN_CLASS);
    window.scrollTo(0, 0);
  };

  const requestPaymentMethod = (guideId, instance, request) => {
    if (isPaymentRequested) {
      return;
    }
    isPaymentRequested = true;

    instance.requestPaymentMethod(request, (err, payload) => {
      if (err) {
        $(document.body).trigger('event:sendPaymentError', [err]);
        $(document.body).trigger('log:paymentLogs', ['[Guide tipping]sale transaction', err]);
        sendRequest('/api/utils/jserror', err);
        return;
      }

      let status = payload.liabilityShifted ? 'liabilityShifted' : 'liabilityNotShifted';
      status += payload.liabilityShiftPossible ? ' - liabilityShiftPossible' : ' - liabilityShiftNotPossible';

      $(document.body).trigger('event:3dsResponse', ['verify card success', status]);

      sendRequest(
        `/api/central/guides/${guideId}/tip`,
        {
          customer_email: EMAIL_INPUT_ELEMENT.value,
          customer_name: NAME_INPUT_ELEMENT.value,
          value: AMOUNT_BREAKDOWN.total,
          currency: AMOUNT_BREAKDOWN.currency,
          payment_method: payload.nonce,
          payment_provider: 'Braintree',
          device_data: payload.deviceData,
          csrf_token: window.csrf,
        },
        (data) => {
          instance.teardown((teardownErr) => {
            if (teardownErr) {
              sendRequest('/api/utils/jserror', teardownErr);
            }
          });

          FINISH_PAYMENT_BUTTON_ELEMENT.classList.add(HIDDEN_CLASS);

          if (!data.success) {
            $(document.body).trigger('log:paymentLogs', ['[Guide tipping]Failed trigger tip save', data]);
            sendRequest('/api/utils/jserror', data);
            displayError(data.message);
            return;
          }

          displaySuccess();
          $(document.body).trigger('log:paymentLogs', ['[Guide tipping]Transaction success', data]);
        },
        {},
        () => {
          $(document.body).trigger('log:paymentLogs', ['[Guide tipping]Failed trigger tip save', 'Payment failed']);
          sendRequest('/api/utils/jserror', 'Payment failed from backend');
          displayError();
        },
      );
    });
  };

  const initDropin = (braintreeSessionToken) => {
    const currencyCode = AMOUNT_BREAKDOWN.currency || parameters.currency;
    dropin.create({
      authorization: braintreeSessionToken,
      container: '#dropin-container',
      dataCollector: true,
      threeDSecure: true,
      translations: {
        chooseAWayToPay: 'How do you want to pay?',
      },
      paypal: {
        flow: 'vault',
      },
      googlePay: {
        merchantId: parameters.google_pay_merchant_id,
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: AMOUNT_BREAKDOWN.total,
          currencyCode,
        },
      },
      applePay: {
        displayName: 'TourRadar',
        paymentRequest: {
          total: {
            label: 'TourRadar',
            amount: AMOUNT_BREAKDOWN.total,
            currencyCode,
          },
        },
      },
    }, (err, instance) => {
      if (err) {
        // Handle any errors that might've occurred when creating Drop-in
        $(document.body).trigger('log:paymentLogs', ['[Guide tipping]Braintree: client create', err]);
        displayError();
        return;
      }

      instance.on('changeActiveView', (event) => {
        if (event.newViewId !== 'card') {
          FINISH_PAYMENT_BUTTON_ELEMENT.classList.add(HIDDEN_CLASS);
        } else {
          FINISH_PAYMENT_BUTTON_ELEMENT.classList.remove(HIDDEN_CLASS);
        }
      });

      // For ApplePay, GooglePay and Paypal we need to call requestPaymentMethod once the payment method is selected.
      instance.on('paymentMethodRequestable', (event) => {
        const request = {
          threeDSecure: {
            amount: AMOUNT_BREAKDOWN.total,
            email: EMAIL_INPUT_ELEMENT.value,
            collectDeviceData: true,
          },
        };

        switch (event.type) {
          case 'AndroidPayCard':
            request.transactionInfo = {
              totalPriceStatus: 'FINAL',
              totalPrice: AMOUNT_BREAKDOWN.total.toString(),
              currencyCode,
            };
            requestPaymentMethod(parameters.guide_id, instance, request);
            break;
          case 'ApplePayCard':
            request.paymentRequest = {
              total: {
                label: 'TourRadar',
                amount: AMOUNT_BREAKDOWN.total,
              },
            };
            requestPaymentMethod(parameters.guide_id, instance, request);
            break;
          case 'PayPalAccount':
            requestPaymentMethod(parameters.guide_id, instance, request);
            break;
          default:
            break;
        }

        selectedPaymentMethod = event.type;
      });

      FINISH_PAYMENT_BUTTON_ELEMENT.addEventListener('click', (e) => {
        e.preventDefault();
        if (!selectedPaymentMethod) {
          return;
        }

        const request = {
          threeDSecure: {
            amount: AMOUNT_BREAKDOWN.total,
            email: EMAIL_INPUT_ELEMENT.value,
            collectDeviceData: true,
          },
        };

        requestPaymentMethod(parameters.guide_id, instance, request);
      });
    });
  };

  const getBraintreeSessionToken = async (currencyCode) => new Promise((resolve, reject) => {
    sendRequest(`/api/central/guides/reload_payments/${currencyCode}`, {}, (data) => {
      if (data.success) {
        return resolve(data.paymentMethods.Braintree.paymentAccess.token);
      }
      displayError();
      return reject(data);
    }, { type: 'GET' }, () => {
      displayError();
      reject();
    });
  });

  const attachEventListeners = () => {
    RADIO_INPUTS_ELEMENTS.forEach((radio) => {
      radio.addEventListener('input', (e) => {
        const selectedAmount = e.target.value;
        setBaseAmount(selectedAmount);
        AMOUNT_INPUT_ELEMENT.value = parseFloat(selectedAmount);
      });
    });

    AMOUNT_INPUT_ELEMENT.addEventListener('input', (e) => {
      const enteredAmount = e.target.value;
      clearRadioInputs();
      setBaseAmount(enteredAmount);
    });

    // Prevent user from submitting white spaces
    NAME_INPUT_ELEMENT.addEventListener('blur', (e) => {
      const enteredValue = e.target.value;
      NAME_INPUT_ELEMENT.value = enteredValue.trim();
    });

    CURRENCY_SELECT_ELEMENT.addEventListener('change', (e) => {
      setCurrency(e.target.value);
    });

    FORM_ELEMENT.addEventListener('submit', async (e) => {
      e.preventDefault();
      FORM_SUBMIT_BUTTON_ELEMENT.disabled = true;
      const braintreeSessionToken = await getBraintreeSessionToken(AMOUNT_BREAKDOWN.currency);
      initDropin(braintreeSessionToken);
      displayDropinSection();
    });
  };

  this.initiate = () => {
    AMOUNT_BREAKDOWN.currency = parameters.currency;
    attachEventListeners();
  };
}

// calls and actions
window.addEventListener('load', () => {
  const guideTippingPage = new GuideTippingPage();

  guideTippingPage.initiate();
});
